import {Component, OnInit} from '@angular/core';
import {DynamicDialogConfig, DynamicDialogRef} from 'primeng/dynamicdialog';
import {SharedImports} from '@shared/shared-imports';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './form-change-confirmation-dialog.html',
  styleUrls: ['./form-change-confirmation-dialog.scss'],
  imports: [SharedImports]
})

export class FormChangeDialogConfirmationComponent implements OnInit {
  message: string;
  acceptLabel: string = 'Confirm';
  rejectLabel: string = 'Cancel';
  header: string;
  icon: string;

  constructor(public config: DynamicDialogConfig, public ref: DynamicDialogRef) {
  }

  ngOnInit(): void {

  }

  cancel() {
    this.ref.close();
  }

  processData() {
    this.ref.close('accept');
  }
}
